import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {PortalItemConfiguration} from "../core/config/portal-item-configuration";
import {LayerObjectType} from "../stores/layer-object-type";

@JsonObject()
export class ApiXhrConfiguration {
    @JsonProperty()
    declare usePost: boolean;
    @JsonProperty()
    declare useProxy?: boolean;
    @JsonProperty()
    declare timeout?: number;
    @JsonProperty()
    declare responseType?: "json" | "xml" | "text" | "blob" | "array-buffer" | "document" | "image";

    constructor() {}
}


@JsonObject()
export class ApiLayerConfiguration {

    @JsonProperty()
    declare objectType: LayerObjectType;

    @JsonProperty()
    declare portalItem: PortalItemConfiguration;

    @JsonProperty()
    declare layerId: number;

    @JsonProperty()
    declare errorMessage: string;

    @JsonProperty()
    declare notFoundMessage: string;

    /**
     * If to filter when project is selected
     */
    @JsonProperty()
    declare projectFilter: boolean;

    /**
     * The topics this API layer belongs to
     */
    @JsonProperty()
    declare topicIds: string[];

    constructor() {}
}

@JsonObject()
export class ApiConfiguration {
    @JsonProperty()
    declare xhrOptions: ApiXhrConfiguration;

    @JsonProperty()
    declare layers: ApiLayerConfiguration[];

    constructor() {}

    getLayerConfig(objectType: LayerObjectType): ApiLayerConfiguration | undefined {
        return this.layers.find((layer: ApiLayerConfiguration) => layer.objectType === objectType);
    }
}
